module.exports = __webpack_public_path__ + "static/img/cahtu-03.5a7e7f42.svg";